export default __webpack_public_path__ + "static/media/OPC_1.83b51c00.png";